import { render } from "./StaticInputsForm.vue?vue&type=template&id=2c7656f6&scoped=true"
import script from "./StaticInputsForm.vue?vue&type=script&lang=js"
export * from "./StaticInputsForm.vue?vue&type=script&lang=js"

import "./StaticInputsForm.vue?vue&type=style&index=0&id=2c7656f6&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c7656f6"]])

export default __exports__